import { useReactiveVar } from '@apollo/client'
import { Backdrop, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import { makeStyles } from '@mui/styles'
import React from 'react'
import { Footer, Header } from '../components/Modules'
import { dropdownStateVar } from '../store/reactiveVars'

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      backdrop: {
        zIndex: 2,
        color: '#fff',
      },
      content: {
        background: theme.palette.background.paper,
        [theme.breakpoints.up('lg')]: {
          marginTop: '11rem',
        },
      },
      section: {
        marginTop: theme.spacing(10),
        [theme.breakpoints.down('lg')]: {
          marginTop: theme.spacing(5),
        },
      },
      footerNewsletterSection: {
        background: theme.palette.primary.dark,
      },
    }),
  { name: 'MuiLayoutSecondaryComponent' },
)

function LayoutSecondary({ categoriesData, ...props }) {
  const { locale } = props
  const classes = useStyles() as any
  const dropdownState = useReactiveVar(dropdownStateVar)

  return (
    <>
      <Backdrop open={dropdownState} className={classes.backdrop} />

      <Header data={categoriesData} locale={locale} />

      <main className={classes.content}>{props.children}</main>

      {/* <SectionAlternate className={classes.footerNewsletterSection}>
        <NewsletterWithImage />
      </SectionAlternate> */}
      <Footer data={categoriesData} locale={locale} />
    </>
  )
}

export default LayoutSecondary
